import { Box, Stack, styled, Table, TableCell, Typography } from '@mui/material';

const A4_WIDTH_PX = 3508;
const A4_HEIGHT_PX = 2480;

export const PricingExportRoot = styled(Stack)(({ theme }) => ({
  width: theme.typography.pxToRem(A4_WIDTH_PX),
  height: theme.typography.pxToRem(A4_HEIGHT_PX),
  position: 'relative',
  flexDirection: 'column',
  flexShrink: 0,
  flexWrap: 'nowrap',
  padding: theme.spacing(3),
  paddingTop: 0,
  color: theme.palette.common.black,
}));

export const PricingExportHeader = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  width: '100%',
  borderBottom: `${theme.typography.pxToRem(1)} solid ${theme.palette.custom.neutral.neutral20}`,
  padding: theme.spacing(8),
  gap: theme.spacing(4),
}));

export const OneVisionLogo = styled(Box)(({ theme }) => ({
  width: theme.typography.pxToRem(160),
  height: theme.typography.pxToRem(160),
  '& img': {
    display: 'block',
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },
}));

export const PartnerLogo = styled(Box)(({ theme }) => ({
  width: theme.typography.pxToRem(600),
  height: theme.typography.pxToRem(120),
  backgroundSize: 'contain',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
}));

export const ExportDate = styled(Typography)(({ theme }) => ({
  marginLeft: 'auto',
  fontSize: theme.typography.pxToRem(45),
}));

export const PricingExportBody = styled(Stack)(({ theme }) => ({
  flex: 1,
  justifyContent: 'center',
  alignItems: 'stretch',
  textAlign: 'left',
  padding: theme.spacing(0, 5),
}));

export const PricingHeader = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(84),
  fontWeight: 700,
  margin: theme.spacing(0, 0, 4, 2),
  alignSelf: 'flex-start',
}));

export const PricingSubheader = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(36),
  margin: theme.spacing(0, 0, 4, 2),
}));

export const PricingTable = styled(Table)(({ theme }) => ({
  borderCollapse: 'unset',
  '& thead': {
    backgroundColor: theme.palette.custom.neutral.neutral87,
  },
}));

export const PricingHeadCell = styled(TableCell)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(28),
  fontWeight: 600,
  color: theme.palette.common.black,
  padding: theme.spacing(5, 2),
  borderBottom: `${theme.typography.pxToRem(1)} solid ${theme.palette.text.secondary}`,
}));

export const PricingBodyCell = styled(TableCell)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(28),
  color: theme.palette.common.black,
  padding: theme.spacing(2),
  borderBottom: `${theme.typography.pxToRem(1)} solid ${theme.palette.text.secondary}`,
}));

export const PricingFooter = styled(Stack)(({ theme }) => ({
  position: 'absolute',
  bottom: theme.spacing(10),
  left: 0,
  width: '100%',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

export const PricingFootnote = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.pxToRem(45),
}));
